(() => {
  const KEY = 'filter.v.availability';
  const VAL = '1';

  // ----------------------------------------------------------------------
  // 1) 【追加】テーマのカスタム並び替えボタンをクリックした時の強制リロード処理
  // ----------------------------------------------------------------------
  document.addEventListener('click', (e) => {
    // クリックされたのが並び替えの選択肢ボタンかどうか判定
    const sortBtn = e.target.closest('#sort-by-selector [data-action="select-value"]');
    if (sortBtn) {
      const sortByValue = sortBtn.getAttribute('data-value');
      
      // ① 現在が /collections/daytona の場合
      if (location.pathname === '/collections/daytona') {
        e.preventDefault();
        e.stopPropagation();
        // filterパラメータを付けずに instock へ遷移（リロード）
        window.location.href = `/collections/daytona-instock?sort_by=${sortByValue}`;
        return;
      }
      
      // ② 現在が /collections/daytona-instock の場合
      if (location.pathname === '/collections/daytona-instock') {
        e.preventDefault();
        e.stopPropagation();
        // そのまま instock 内で並び替えのみを適用して遷移（リロード）
        window.location.href = `/collections/daytona-instock?sort_by=${sortByValue}`;
        return;
      }
    }
  }, true); // true: キャプチャフェーズでテーマの標準JSよりも先に検知・処理する


  // ----------------------------------------------------------------------
  // 2) 既存の Ajax URL書き換え処理（他のコレクション用）
  // ----------------------------------------------------------------------
  const shouldPatch = (u) => {
    // daytona と daytona-instock の場合はフィルター追加パッチを除外
    if (u.pathname === '/collections/daytona' || u.pathname === '/collections/daytona-instock') return false;

    // コレクション/検索の一覧更新にだけ当てる
    return (
      u.pathname.startsWith('/collections/') ||
      u.pathname.startsWith('/search')
    );
  };

  const addAvail = (inputUrl) => {
    try {
      const u = new URL(inputUrl, location.origin);
      if (!shouldPatch(u)) return inputUrl;

      // sort_by がある＝並び替えが絡む時に強制
      if (u.searchParams.has('sort_by')) {
        if (!u.searchParams.has(KEY)) u.searchParams.set(KEY, VAL);
      }
      return u.toString();
    } catch {
      return inputUrl;
    }
  };

  // 標準の select タグを使用した場合のフォールバック
  document.addEventListener('change', (e) => {
    const el = e.target;
    if (!(el instanceof HTMLSelectElement)) return;
    if (el.name !== 'sort_by') return;

    const u = new URL(location.href);

    if (u.pathname === '/collections/daytona' || u.pathname === '/collections/daytona-instock') {
      window.location.href = `/collections/daytona-instock?sort_by=${el.value}`;
      return;
    }

    u.searchParams.set('sort_by', el.value);
    if (!u.searchParams.has(KEY)) u.searchParams.set(KEY, VAL);
    history.replaceState({}, '', u.toString());
  });

  // fetch をパッチ
  const _fetch = window.fetch;
  window.fetch = function (input, init) {
    try {
      if (typeof input === 'string') {
        input = addAvail(input);
      } else if (input instanceof Request) {
        const patchedUrl = addAvail(input.url);
        if (patchedUrl !== input.url) {
          input = new Request(patchedUrl, input);
        }
      }
    } catch {}
    return _fetch.call(this, input, init);
  };

  // XHR をパッチ
  const _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    try {
      if (typeof url === 'string') url = addAvail(url);
    } catch {}
    return _open.call(this, method, url, ...rest);
  };

  // ----------------------------------------------------------------------
  // 3) 初回ロード時のURL補正
  // ----------------------------------------------------------------------
  (() => {
    const u = new URL(location.href);

    // 外部からのリンク等で daytona に sort_by 付きで直接アクセスされた場合のリダイレクト
    if (u.pathname === '/collections/daytona' && u.searchParams.has('sort_by')) {
      window.location.replace(`/collections/daytona-instock?sort_by=${u.searchParams.get('sort_by')}`);
      return;
    }

    // 他コレクション用のフィルター付与
    if (u.searchParams.has('sort_by') && !u.searchParams.has(KEY)) {
      if (!shouldPatch(u)) return; // デイトナ等は無視
      u.searchParams.set(KEY, VAL);
      history.replaceState({}, '', u.toString());
    }
  })();
})();